<div class="search-advanced-items">
  <div class="search-advanced-pane full-width">
    <div class="filter-group" data-group-visibility-id="showFreeTextRules">
      <div class="filter-group-header">
        <div class="filter">
          <span class="input-group-btn">
            <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showFreeTextRules" (click)="filter.groupVisibility.showFreeTextRules = !filter.groupVisibility.showFreeTextRules; updateFilter()"></button>
          </span>
          <span class="filter-body">
            <span class="filter-title">
              Free-text Rules
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>

  @if (navigationEnabled || filter.groupVisibility.showFreeTextRules) {
    <div style="padding-left: 42px" [class.collapsed]="!filter.groupVisibility.showFreeTextRules">
      <div class="row row-total row-justify-content-left">
        <div class="info reset-font">
          These rules will be inserted at the very top and at the bottom of the filter, respectively.
          <br /><strong>Warning!</strong> These rules could hide items unintentionally, and invalid syntax will cause the filter not to load. Use at your own risk!
          Please read about how filters work on the <a href="https://www.pathofexile.com/item-filter/about" target="_blank">official page</a>.
        </div>
      </div>

      <div class="search-advanced-pane blue">

        <div class="filter-group">
          <div class="filter-group-header">
            <div class="filter">
              <span class="filter-body">
                <span class="filter-title">
                  Insert At Top
                </span>
              </span>
            </div>
          </div>
          <div class="filter-group-body">

            <div class="filter filter-property full-span">
              <textarea class="custom-rules" [(ngModel)]="filter.freeRulesTop" (keyup)="updateFilter()"></textarea>
            </div>

          </div>

          <div class="clear"></div>
        </div>

      </div>

      <div class="search-advanced-pane blue">

        <div class="filter-group">
          <div class="filter-group-header">
            <div class="filter">
              <span class="filter-body">
                <span class="filter-title">
                  Insert At Bottom
                </span>
              </span>
            </div>
          </div>
          <div class="filter-group-body">

            <div class="filter filter-property full-span">
              <textarea class="custom-rules" [(ngModel)]="filter.freeRulesBottom" (keyup)="updateFilter()"></textarea>
            </div>

          </div>

          <div class="clear"></div>
        </div>
      </div>
    </div>
  }
</div>
